import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Input,
  CardImg,
  CardSubtitle,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { formValidation, mapDataForDropDown } from "helpers/helpers"
import Dropzone from "react-dropzone"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"
// Form Editor
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError, removeError } from "store/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import { createStaticPage } from "store/StaticPages/actions"
import {sitename} from "../../../constants/constants";
const Create = props => {
  const dispatch = useDispatch()
  const [page_type, set_page_type] = useState({
    label: "",
    value: "",
  })
  const [details, set_details] = useState("")

  useEffect(() => {
    dispatch(apiError(""))
  }, [])

  const urlParams = new URLSearchParams(props.location.search)

  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      id: +urlParams.get("id"),
      page_type: page_type?.label,
      details: details,
    }
    dispatch(createStaticPage(data, props.history))
  }

  const formErrors = useSelector(state => state?.CommonState)
  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Bonuses" breadcrumbItem="Create" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              Create Static Page
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Page
                  </Label>
                  <Col sm={5}>
                    <Select
                      maxMenuHeight={150}
                      onChange={page_type => {
                        removeError("page_type")
                        set_page_type(page_type)
                      }}
                      options={[
                        {
                          value: "Responsible Gaming",
                          label: "Responsible Gaming",
                        },
                        {
                          value: "Betting Rules",
                          label: "Betting Rules",
                        },
                        {
                          value: "Privacy Policy",
                          label: "Privacy Policy",
                        },
                        {
                          value: "Cookies Policy",
                          label: "Cookies Policy",
                        },
                        {
                          value: "Terms and Conditions",
                          label: "Terms and Conditions",
                        },
                        {
                          value: "FAQ's",
                          label: "FAQ's",
                        },
                        {
                          value: "Contact us",
                          label: "Contact us",
                        },
                      ]}
                      classNamePrefix="select2-selection"
                      value={{
                        label: page_type?.label,
                        value: page_type?.value,
                      }}
                    />
                    {formErrors?.page_type ? (
                      <FieldValidation errorMessage={formErrors?.page_type} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Details
                  </Label>
                  <Col sm={5}>
                    <CKEditor
                      editor={ClassicEditor}
                      data=""
                      onReady={editor => {
                        // You can store the "editor" and use when it is needed.
                      }}
                      onChange={(event, editor) => {
                        removeError("details")
                        const data = editor.getData()
                        set_details(data)
                      }}
                      // value={details}
                    />
                    {formErrors?.details ? (
                      <FieldValidation errorMessage={formErrors?.details} />
                    ) : null}
                  </Col>
                </div>

                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/crm/static-pages")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const CreateStaticPages = withRouter(Create)
